import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'asideLayoutStructurePage',
  components: {
  },
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      title: 'aside-layout-structure-page',
      dataPropVal: this.dataProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('structure-layout-change', { action, payload: { data } })
      }
    }
  },
  mounted () {}
}
